<template>
    <div>
        <div align="center" id="detail" style="display: block;">
            <table :class="tableClass">
                <caption>{{this.$t('Calculette.result.bilan')}}</caption>
                <thead class="hidden">
                    <tr>
                        <th scope="col">{{this.$t('general.resultat')}}</th>
                        <th scope="col">{{this.$t('general.valeur')}}</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-if="!(resultat.isBaremeAjuste || resultat.isBaremeRectif)">
                    <td :class='colLeft'>  {{ resultat.solde > 0 ? $t("Calculette.result.remboursement") : $t("Calculette.result.sommeContribuable") }}
                    </td>
                    <td :class='colRight'><b>{{resultat.solde | currency}} CHF</b></td>
                </tr>
                <tr v-if="(resultat.isBaremeRectif)">
                    <td :class='colLeft'>  {{ (Number(resultat.solde)) > 0 ? $t("Calculette.result.remboursement")
                        : $t("Calculette.result.sommeContribuable") }}
                    </td>
                    <td :class='colRight'><b>{{Math.abs(resultat.solde) | currency}}</b></td>
                </tr>
                <tr v-if="(resultat.isBaremeAjuste)">
                    <td :class='colLeft'>  {{ (Number(resultat.solde)) > 0 ? $t("Calculette.result.sommeReclame2")
                        :  $t("Calculette.result.sommeRembourse")}}
                    </td>
                    <td :class='colRight'><b>{{Math.abs(resultat.solde) | currency}}</b></td>
                </tr>
                </tbody>
            </table>
            <br>
        </div>
        <div v-if="(resultat.isBaremeRectif)">
            <!-- Message si solde < -800 CHF-->
            <blockquote v-if="Number(resultat.solde) < -800">
                <p v-html="$t('Calculette.result.provisionnerCompte', {url: 'https://www.ge.ch/contacter-afc'})"></p>
            </blockquote>
            <!-- Message si solde > 500 CHF-->
            <blockquote v-if="Number(resultat.solde) > 500">
                <p v-html="$t('Calculette.result.remplirFormulairePrelevement', {url:'https://ge.ch/afcael2pub/formulaire-prelevement'})"></p>
            </blockquote>
        </div>
        <div v-if="(resultat.isBaremeAjuste && Number(resultat.solde)) > 0">
            <blockquote >
                <p v-html="$t('Calculette.result.provisionnerCompteAjuste', {url: 'https://www.ge.ch/contacter-afc'})"></p>
            </blockquote>
        </div>
    </div>
</template>

<script>
export default {
  name: 'section-bilan',
  props: ['resultat', 'colLeft', 'colRight', 'tableClass'],
};
</script>

<style scoped>

</style>
